var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-user-others-item-label",on:{"click":_vm.$_clickLabel}},[_c('div',{staticClass:"label-wrapper",style:({ height: `${_vm.height}px` })},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"link"},[_c('IconLinkArrow')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }